import { createContext } from 'react';
export default createContext({
  id: 0,
  dispatch: function dispatch() {}
});